function benefitsList() {
	return [
		{
			text: 'Antes de contratar',
			url: 'antes-de-contratar',
		},
		{
			text: 'Durante la vigencia del contrato',
			url: 'vigencia-del-contrato',
		},
		{
			text: 'Al vencimiento del contrato',
			url: 'vencimiento-del-contrato',
		},
	]
}

export default benefitsList
